/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsjoinershint2Inputs */

const en_statsjoinershint2 = /** @type {(inputs: Statsjoinershint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`People who joined as going, maybe or on the way. A plan’s creator counts too.`)
};

const de_statsjoinershint2 = /** @type {(inputs: Statsjoinershint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personen, die zugesagt, vielleicht gesagt haben oder unterwegs sind. Wer einen Plan erstellt, zählt mit.`)
};

/**
* | output |
* | --- |
* | "People who joined as going, maybe or on the way. A plan’s creator counts too." |
*
* @param {Statsjoinershint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsjoinershint2 = /** @type {((inputs?: Statsjoinershint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsjoinershint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsjoinershint2(inputs)
	return de_statsjoinershint2(inputs)
});
export { statsjoinershint2 as "statsJoinersHint" }